// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination_paginationWrapper__wcRcA {
  display: flex;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none; }

.pagination_info__IjKQ8 {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: var(--HightEmphasis);
  padding: 0 10px; }

.pagination_pageItem__5lbnk {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  height: 24px;
  width: 24px;
  color: var(--HightEmphasis);
  cursor: pointer; }
  .pagination_pageItem__5lbnk:hover {
    text-decoration: underline; }
  .pagination_pageItem__5lbnk:focus {
    outline: 0; }

.pagination_disabled__PoiTs {
  color: var(--LowEmphasis); }
`, "",{"version":3,"sources":["webpack://./src/components/pagination/pagination.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;ECgCnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDhCjB,2BAA2B;EAC3B,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,eAAe,EAAA;EATjB;IAYI,0BAA0B,EAAA;EAZ9B;IAgBI,UAAU,EAAA;;AAId;EACE,yBAAyB,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.paginationWrapper {\n  display: flex;\n  justify-content: center;\n  user-select: none;\n}\n\n.info {\n  display: flex;\n  align-items: center;\n  @include body2;\n  color: var(--HightEmphasis);\n  padding: 0 10px;\n}\n\n.pageItem {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  height: 24px;\n  width: 24px;\n  color: var(--HightEmphasis);\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.disabled {\n  color: var(--LowEmphasis);\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationWrapper": `pagination_paginationWrapper__wcRcA`,
	"info": `pagination_info__IjKQ8`,
	"pageItem": `pagination_pageItem__5lbnk`,
	"disabled": `pagination_disabled__PoiTs`
};
export default ___CSS_LOADER_EXPORT___;
